module.exports = __webpack_public_path__ + "img/JP-COVER.51a1fe07.png";